import '../css/home.css';
import '../css/wa.css';
import '../styles/HeadlineCarousel.css';
import '../css/mb.css';
import { MdOutlineArrowForwardIos, MdEdit } from "react-icons/md"
import { IoMdSend } from "react-icons/io";
import React, { useEffect, useState } from 'react';
import { FaUser } from "react-icons/fa";
import { IoTimeOutline, IoHeart, IoNotificationsOutline } from "react-icons/io5";
import { FaCommentAlt, FaFireAlt, FaRegNewspaper, FaEye, FaCheckCircle } from "react-icons/fa";
import axios from "axios"
import { MdArrowForwardIos } from "react-icons/md";
import HeadlineCarousel from '../components/headline';
import BoxHandler from '../components/BoxHandler.js';
import MyInformation from '../components/myInfomation';
import { fetchUserData } from '../api/getUserData'; // 위에서 작성한 함수
import { useToast } from "../components/ToastProvider";


const Home = () => {
  const [loading, setLoading] = useState(true); // 로딩 상태
  const [notLogined, setNotLogined] = useState(false); // 로그인되지 않은 상태
  const [subView, setSubView] = useState({ articles: [] });
  const [subsData, setSubsData] = useState({ processedData: [], mergedArticles: [] });
  const [subsAll, setSubsAll] = useState([]);
  const [lemail, setlEmail] = useState('');
  const [chatData, setChatData] = useState([]);
  const [chatInput, setChatInput] = useState(null);
  const [savedArticles, setSavedArticles] = useState([]);
  const [hotArticle, setHotArticle] = useState([]);
  const [hotNews, setHotNews] = useState([]);
  const [hotQ, setHotQ] = useState([]);
  const [tradingSearch, setTradingSearch] = useState([]);
  const [myArticle, setMyArticle] = useState([]);
  const [events, setEvents] = useState([]);
  const [isNewsLetter, setIsNewsLetter] = useState(false);
  const [myArticleRecent, setMyArticleRecent] = useState([]);
  const [hotExpert, setHotExpert] = useState([]);

  const showToast = useToast();

  useEffect(() => {
      const url = process.env.REACT_APP_API_BASE_URL;
      console.log(url);
      const token = localStorage.getItem('token'); // 로컬 스토리지에서 토큰 가져오기
      if (!token) {
          setNotLogined(true); // 토큰이 없으면 notLogined 활성화
          setLoading(false);
          return;
      }



      const getSubsData = async () => {
          const token = localStorage.getItem('token'); // 로컬 스토리지에서 토큰 가져오기
          if (token) {
            try {
                const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/subs`, { token });
                setSubsData(data.results);
                setSubsAll(data.results.mergedArticle);
                setSavedArticles(data.savedArticles);
                console.log(data.results.mergedArticles)
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
          }
          setSubView('all')
      };

      getSubsData();
  }, []); // 컴포넌트가 처음 렌더링될 때 실행



useEffect(() => {
   
    const getChatData = async () => {
      try {
          console.log("Requesting chat data...");
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/chat`, {});
          setChatData(data.chatResult);
          console.log('t', data.chatResult);
          
      } catch (error) {
          console.error("Error fetching chat data:", error.response || error);
      }
    };

    const isNewsLetterCheck = async () => {
      try {
          const token = localStorage.getItem('token'); // 로컬 스토리지에서 토큰 가져오
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/newsletter/check`, { token });
          setIsNewsLetter(data.isNewsLetter);
          
      } catch (error) {
          console.error("Error fetching data:", error.response || error);
      }
    };

    const getHotArticle = async () => {
      try {
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/hot/all`, {});
          setHotArticle(data.results);
          setHotExpert(data.expert);
      } catch (error) {
          console.error("Error fetching chat data:", error.response || error);
      }
    };
    const getHotNews = async () => {
      try {
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/hot/byhead`, { head: 'NEWS' });
          setHotNews(data.results);
          
      } catch (error) {
          console.error("Error fetching chat data:", error.response || error);
      }
    };
    const getHotQnA = async () => {
      try {
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/hot/byhead`, { head: 'Q' });
          setHotQ(data.results);
          console.log(data)
      } catch (error) {
          console.error("Error fetching chat data:", error.response || error);
      }
    };
    const getQna = async () => {
      try {
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/getqna`, {});
          setHotQ(data.results);
          
      } catch (error) {
          console.error("Error fetching chat data:", error.response || error);
      }
    };
    const getTrading = async () => {
      try {
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/gettrading`, {});
          setTradingSearch(data.search);
          console.log(data)
      } catch (error) {
          console.error("Error fetching chat data:", error.response || error);
      }
    };
    const getMyArticle = async () => {
      try {
          const token = localStorage.getItem('token'); // 로컬 스토리지에서 토큰 가져오기
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/getmyarticle`, { token });
          setMyArticle(data.results);
          setMyArticleRecent(data.recent);
      } catch (error) {
          console.error("Error fetching data:", error.response || error);
      }
    };
    const getEvents = async () => {
          try {
              let { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/event`, {
            });
            console.log(data);
            setEvents(data.results);
        } catch (error) {
            alert('e')
        }
    };
    getEvents();
    isNewsLetterCheck();
    getMyArticle();
    getTrading();
    getHotQnA();
    getHotNews();
    getHotArticle();
}, []); // 컴포넌트가 처음 렌더링될 때 실행

  
  const sendChat = async () => {
      const token = localStorage.getItem('token'); // 로컬 스토리지에서 토큰 가져오기

      if (!token) {
          console.error("No token found");
          return;
      }

      if (!chatInput) { // Ensure chatInput is not empty
          console.error("Chat input is empty");
          return;
      }

      try {
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/chat_send`, {
              token,
              content: chatInput,
          });
          setChatData(data.results);
      } catch (error) {
          console.error("Error:", error);
      }

      try {
          console.log("Requesting chat data...");
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/chat`, {});
          console.log("Chat data received:", data);
          setChatData(data.chatResult);
      } catch (error) {
          console.error("Error fetching chat data:", error.response || error);
      }
      
      setChatInput('')
      setSubView('all');
  };



  const submitNewsletter = async () => {
      try {
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/newsletter/submit`, {
              email: lemail
          });
      } catch (error) {
          console.error("Error:", error);
      }
      setIsNewsLetter(true);
  };


  const getRandomPastelColor = () => {
    const hue = Math.floor(Math.random() * 360);
    return `hsl(${hue}, 70%, 90%)`;
  };

  const maxCount = Math.max(...tradingSearch.map((k) => k.count));
  const minSize = 10;
  const maxSize = 30;

    return (
      <>
        <div className='ma-18'>
          <div className='hm-ct'>
            <div className='hm-main-area'>
              
              <div className='hm-headline-ct'>
                <HeadlineCarousel />
              </div>
              
              <div className='hm-main-inner'>
                <div className='hm-line'>
                  <div className="wa-card">
                    <BoxHandler 
                      options={{
                        title: '오늘의 인기글',
                        tabs: ['전체']
                      }}
                      titleRight={<MdOutlineArrowForwardIos className='wa-title-into' />}
                    >
                      <div className="news-1">
                        {hotArticle.map((article) => (
                              <div className="cm-card-list-item" onClick={() => window.location.href = `/community/article/${article.id}`}>
                                  <div className='cm-view'><FaEye />{article.view}</div>
                                  {article.previewImage ? 
                                  <div className="cm-card-list-item-thumb wa-thumb"><img src={article.previewImage}></img></div>
                                  : null }
                                  <div className="cm-card-list-item-content">
                                      <div className="cm-card-list-item-title"><span style={{fontWeight:600,color:article.headColor}}>[{article.headName}] </span>{article.title}</div>
                                      <div className="cm-card-list-item-meta">
                                          <IoTimeOutline />
                                          <span className="meta-time">{article.date}</span>
                                          <span className="meta-divider">·</span>
                                          <span className="meta-likes">
                                              <IoHeart />
                                              {article.like}
                                          </span>
                                          <span className="meta-divider">·</span>
                                          <span className="meta-comments">
                                              <FaCommentAlt className='icon-smaller' />
                                              {article.commentCount}
                                          </span>
                                          <span className="meta-divider">·</span>
                                          <span className="meta-time">
                                            <FaUser />
                                            {article.username} 
                                            {article.expert === '1' && <FaCheckCircle className='check' />}
                                          </span>
                                      </div>
                                  </div>
                              </div>
                          ))}

                      </div>
                      <div className="news-2">
                      </div>
                    </BoxHandler>
                  </div>
                  <div className="wa-card">
                    <BoxHandler 
                      options={{
                        title: '오늘의 뉴스',
                        tabs: ['전체']
                      }}
                      titleRight={<MdOutlineArrowForwardIos className='wa-title-into' />}
                    >
                      <div className="news-1">
                        {hotNews.map((article) => (
                              <div className="cm-card-list-item" onClick={() => window.location.href = `/community/article/${article.id}`}>
                                  <div className='cm-view'><FaEye />{article.view}</div>
                            
                                  {article.previewImage ? 
                                  <div className="cm-card-list-item-thumb wa-thumb"><img src={article.previewImage}></img></div>
                                  : null }
                                  <div className="cm-card-list-item-content">
                                      <div className="cm-card-list-item-title">{article.title}</div>
                                      <div className="cm-card-list-item-meta">
                                          <IoTimeOutline />
                                          <span className="meta-time">{article.date}</span>
                                          <span className="meta-divider">·</span>
                                          <span className="meta-likes">
                                              <IoHeart />
                                              {article.like}
                                          </span>
                                          <span className="meta-divider">·</span>
                                          <span className="meta-comments">
                                              <FaCommentAlt className='icon-smaller' />
                                              {article.commentCount}
                                          </span>
                                          <span className="meta-divider">·</span>
                                          <span className="meta-time">
                                            <FaUser />
                                            {article.username} 
                                            {article.expert === '1' && <FaCheckCircle className='check' />}
                                          </span>
                                      </div>
                                  </div>
                              </div>
                          ))}
                      </div>
                      <div className="news-2">카테고리 1 내용</div>
                      <div className="news-3">카테고리 2 내용</div>
                    </BoxHandler>

                  </div>  
                  
                </div>


                <div className='hm-line'>
                  <div className="wa-card">
                    <div className="wa-card-title">익스퍼트 인기글</div>
                    {hotExpert.map((article) => (
                      <div
                        key={article.id}
                        className="cm-card-list-item"
                        onClick={() => (window.location.href = `/community/article/${article.id}`)}
                      >
                        <div className='cm-view'><FaEye />{article.view}</div>
                        <div className="experthot">
                        </div>
                        {article.previewImage ? (
                          <div className="cm-card-list-item-thumb wa-thumb">
                            <img src={article.previewImage || "/placeholder.svg"} alt="" />
                          </div>
                        ) : null}
                        <div className="cm-card-list-item-content">
                          <div className="cm-card-list-item-title">
                            <span style={{ fontWeight: 600, color: article.headColor }}>[{article.headName}]</span>
                            {article.title}
                          </div>
                          <div className="cm-card-list-item-meta">
                            <IoTimeOutline />
                            <span className="meta-time">{article.date}</span>
                            <span className="meta-divider">·</span>
                            <span className="meta-likes">
                              <IoHeart />
                              {article.like}
                            </span>
                            <span className="meta-divider">·</span>
                            <span className="meta-comments">
                              <FaCommentAlt className="icon-smaller" />
                              {article.commentCount}
                            </span>
                            <span className="meta-divider">·</span>
                            <span className="meta-time">
                              <FaUser />
                              {article.username}<FaCheckCircle className='check' />
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {notLogined ? 
                  <>
                  </> : 
                    <>
                      <div className="wa-card">
                        <div className='wa-card-title'>구독</div>
                        <div className="hm-subs-1">
                          <div className='hm-sub-list-ct'>
                            <div className={`hm-sub-list ${subView === "all" ? "selected" : ""}`} onClick={() => setSubView("all")}>전체보기</div>
                            
                            {subsData?.processedData.map((sub) => (
                              <div
                              className={`hm-sub-list ${subView?.userId === sub.userId ? 'selected' : ''}`}
                              onClick={() => setSubView(sub)}>{sub.username}</div>
                            ))}
                          </div>
                          <div className='hm-sub-view'>

                            {subView === "all" ? (
                              <>
                                {subsData?.mergedArticles.map((at) => (
                                  <div key={at.id} className="wa-card-list-item" onClick={() => window.location.href = `/community/article/${at.id}`}>
                                    {at.previewImage ? 
                                    <div className="cm-card-list-item-thumb wa-thumb"><img src={at.previewImage}></img></div>
                                    : null }
                                    <div className="wa-card-list-item-content">
                                      <div className="wa-card-list-item-title">{at.title}</div>
                                      <div className="wa-card-list-item-meta">
                                        <IoTimeOutline />
                                        <span className="meta-time">{at.date}</span>
                                        <span className="meta-divider">·</span>
                                        <span className="meta-likes">
                                          <IoHeart />
                                          {at.like}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </>
                            ) : (
                              <>
                                <div style={{display:'flex'}}>
                                  <div style={{display:'block'}}>
                                    {subView?.articles.map((at) => (
                                      <div key={at.id} className="wa-card-list-item" onClick={() => window.location.href = `/community/article/${at.id}`}>
                                        {at.previewImage ? 
                                        <div className="cm-card-list-item-thumb wa-thumb"><img src={at.previewImage}></img></div>
                                        : null }
                                        <div className="wa-card-list-item-content">
                                          <div className="wa-card-list-item-title">{at.title}</div>
                                          <div className="wa-card-list-item-meta">
                                            <IoTimeOutline />
                                            <span className="meta-time">{at.date}</span>
                                            <span className="meta-divider">·</span>
                                            <span className="meta-likes">
                                              <IoHeart />
                                              {at.like}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>

                                  <div
                                    className="hm-sub-side"
                                    onClick={() => window.location.href = `/profile/${subView.userId}`}
                                  >
                                    <div className="hm-sub-profile">
                                      <div className="hm-sub-profile-img wa-profile">
                                        <img src={subView.profile} alt="Profile" />
                                      </div>
                                      <div className="hm-sub-profile-name">{subView.username}</div>
                                    </div>

                                    <div className="hm-sub-profile-view">
                                      프로필 보기 <MdOutlineArrowForwardIos />
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                    </div>

                    <div className="wa-card">
                        <div className='wa-card-title'>저장한 글</div>
                        <div className="subs-1">
                            {savedArticles.map((at) => (
                              <div key={at.id} className="wa-card-list-item" onClick={() => window.location.href = `/community/article/${at.id}`}>
                                {at.previewImage ? 
                                  <div className="cm-card-list-item-thumb wa-thumb"><img src={at.previewImage}></img></div>
                                : null }
                                <div className="wa-card-list-item-content">
                                  <div className="wa-card-list-item-title">{at.title}</div>
                                  <div className="wa-card-list-item-meta">
                                    <IoTimeOutline />
                                    <span className="meta-time">{at.date}</span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-likes">
                                      <IoHeart />
                                      {at.like}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                    </div>

                    

                    <div className="wa-card">
                      <BoxHandler 
                        options={{
                          title: '내 분야의 글',
                          tabs: ['인기 글', '최신 글']
                        }}
                        titleRight={<MdOutlineArrowForwardIos className='wa-title-into' />}
                      >
                        <div className="news-1">
                          {myArticle.map((article) => (
                                <div className="cm-card-list-item" onClick={() => window.location.href = `/community/article/${article.id}`}>
                                    <div className='cm-view'><FaEye />{article.view}</div>
                              
                                    {article.previewImage ? 
                                    <div className="cm-card-list-item-thumb wa-thumb"><img src={article.previewImage}></img></div>
                                    : null }
                                    <div className="cm-card-list-item-content">
                                        <div className="cm-card-list-item-title"><span style={{fontWeight:600,color:article.headColor}}>[{article.headName}] </span>{article.title}</div>
                                        <div className="cm-card-list-item-meta">
                                            <IoTimeOutline />
                                            <span className="meta-time">{article.date}</span>
                                            <span className="meta-divider">·</span>
                                            <span className="meta-likes">
                                                <IoHeart />
                                                {article.like}
                                            </span>
                                            <span className="meta-divider">·</span>
                                            <span className="meta-comments">
                                                <FaCommentAlt className='icon-smaller' />
                                                {article.commentCount}
                                            </span>
                                            <span className="meta-divider">·</span>
                                            <span className="meta-time">
                                              <FaUser />
                                              {article.username} 
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="news-2">
                            {myArticleRecent.map((article) => (
                                <div className="cm-card-list-item" onClick={() => window.location.href = `/community/article/${article.id}`}>
                                    <div className='cm-view'><FaEye />{article.view}</div>
                              
                                    <div className="cm-card-list-item-thumb wa-thumb"><img src={article.previewImage}></img></div>
                                    <div className="cm-card-list-item-content">
                                        <div className="cm-card-list-item-title"><span style={{fontWeight:600,color:article.headColor}}>[{article.headName}] </span>{article.title}</div>
                                        <div className="cm-card-list-item-meta">
                                            <IoTimeOutline />
                                            <span className="meta-time">{article.date}</span>
                                            <span className="meta-divider">·</span>
                                            <span className="meta-likes">
                                                <IoHeart />
                                                {article.like}
                                            </span>
                                            <span className="meta-divider">·</span>
                                            <span className="meta-comments">
                                                <FaCommentAlt className='icon-smaller' />
                                                {article.commentCount}                                                                                                                                                                                                                                                                                                                             
                                            </span>
                                            <span className="meta-divider">·</span>
                                            <span className="meta-time">
                                              <FaUser />
                                              {article.username} 
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                      </BoxHandler>
                    </div>
                    </>
                  }
                  <div className="wa-card">
                    <BoxHandler 
                      options={{
                        title: '오늘의 Q&A',
                        tabs: ['전체']
                      }}
                      titleRight={<MdOutlineArrowForwardIos className='wa-title-into' />}
                    >
                      <div className="news-1">
                        {hotQ.map((article) => (
                              <div className="cm-card-list-item" onClick={() => window.location.href = `/community/article/${article.id}`}>
                                  <div className='cm-view'><FaEye />{article.view}</div>
                            
                                  {article.previewImage ? 
                                  <div className="cm-card-list-item-thumb wa-thumb"><img src={article.previewImage}></img></div>
                                  : null }
                                  <div className="cm-card-list-item-content">
                                      <div className="cm-card-list-item-title">{article.title}</div>
                                      <div className="cm-card-list-item-meta">
                                          <IoTimeOutline />
                                          <span className="meta-time">{article.date}</span>
                                          <span className="meta-divider">·</span>
                                          <span className="meta-likes">
                                              <IoHeart />
                                              {article.like}
                                          </span>
                                          <span className="meta-divider">·</span>
                                          <span className="meta-comments">
                                              <FaCommentAlt className='icon-smaller' />
                                              {article.commentCount}
                                          </span>
                                          <span className="meta-divider">·</span>
                                          <span className="meta-time">
                                            <FaUser />
                                            {article.username} 
                                            {article.expert === '1' && <FaCheckCircle className='check' />}
                                          </span>
                                      </div>
                                  </div>
                              </div>
                          ))}
                      </div>
                      <div className="news-2">최신 qna</div>
                      <div className="news-2">내 주제 qna</div>
                    </BoxHandler>
                  </div>
                </div>
              </div>
            </div>
            <div className='hm-side-area'>
              <MyInformation className='mbh'/>
              {isNewsLetter ? 
              <></>
              :
              <div className='wa-card newsletter'>
                  <div className='title'>뉴스레터 구독하고 받기</div>
                  <div className='desc'>최신 에너지 뉴스를 이메일로 받아볼 수 있습니다.</div>
                  <div className='bxl'>
                    <input placeholder='이메일 입력'
                     onChange={(e) => setlEmail(e.target.value)}
                     value={lemail}></input>
                    <button onClick={submitNewsletter}>등록</button>
                  </div>
              </div>
              }

              <div className='wa-card'>
                <div className='wa-card-title'>실시간 인기 검색어</div>
                <div className="wa-trading-keywords">
                  {tradingSearch.map((keyword, index) => {
                    const fontSize =
                      minSize +
                      ((keyword.count / maxCount) * (maxSize - minSize)); // 비율에 따른 크기 조절
                    return (
                      <span
                        key={index}
                        onClick={() => window.location.href = `/search/${keyword.keyword}`}
                        className="keyword"
                        style={{
                          fontSize: `${fontSize}px`,
                          backgroundColor: getRandomPastelColor(),
                          borderRadius: "8px",
                          margin: "5px",
                          display: "inline-block",
                        }}
                      >
                        {keyword.keyword} 
                        <span className='small'>{keyword.count}번 검색</span>
                      </span>
                    );
                  })}
                </div>
              </div>
              
              <div className="wa-card events" style={{marginBottom:0}}>
                  <div className='wa-card-title'>이벤트와 소식</div>
                  <div className='event-ct'>
                    {events.map((at) => (
                        <div className='mt-article' onClick={() => window.location.href = `/community/article/${at.id}`}>
                            <div className='mt-article-left'>
                                <div className='mt-article-title'>{at.title}</div>
                                <div className='mt-article-desc' style={{fontSize:15}}>{at.preview}</div>
                                <div className='mt-article-desc' style={{color:'gray',fontSize:12}}>{at.date}</div>
                            </div>
                            <div className='mt-article-view'>
                                읽기 <MdArrowForwardIos/>
                            </div>
                        </div>
                    ))}
                  </div>
              </div>
              <div className="wa-card" style={{marginBottom:0,display:'none'}}>
                  <div className='wa-card-title'>채팅</div>
                  
                      <div className='hm-chat-ct'>
                      {chatData?.map((ch) => (
                        <div className='hm-chat-bal'>
                          <div className='hm-chat-profile'>
                            <div className='hm-chat-pfi wa-profile'><img src={ch.writerInfo.profile}></img></div>
                            <div className='hm-chat-profile-name'>{ch.writerInfo.username}</div>
                          </div>
                          <div className='hm-chat-content'>{ch.content}</div>
                          <div className='hm-chat-time'>{ch.time}</div>
                        </div>
                      ))}
                        </div>
                          <div className='hm-chat-input'>
                            <input   placeholder={notLogined ? "로그인하고 참여하세요" : "채팅을 시작하세요"}
                              value={chatInput}
                              onChange={(event) => setChatInput(event.target.value)}
                            ></input>
                            {notLogined ? " " : 
                            <div className='hm-chat-send' onClick={() => sendChat()}>
                              <IoMdSend />
                            </div>  }
                        </div>
                    </div>
              </div>

          </div>
        </div>
      </>
    );
  };

  export default Home;